import convertSecondsToDaysToDays from "./convertSecondsToDays";
import React from "react";
import { showModal } from "../../../../../../lib/react-redux-modal-provider";

const showPaymentBarDowngradeToFreeModal = ({
  translate,
  selectedPlan,
  userData,
  paymentDetails
}) => {
  return showModal("NewModal", {
    title: translate("plans_payment-bar_modal-title"),
    acceptButtonText: translate("Ok"),
    children: (
      <>
        <p className={"text-sm text-black opacity-70 mb-6"}>
          {translate(
            "plans_payment-bar_no-subscription_downgrade-to-free %{userCurrentPlanName} %{newPlanName} %{days}",
            {
              userCurrentPlanName: userData?.current_plan?.name,
              newPlanName: selectedPlan?.name,
              days: convertSecondsToDaysToDays(
                paymentDetails?.end_date_in_seconds
              )
            }
          )}
        </p>
      </>
    )
  });
};

export default showPaymentBarDowngradeToFreeModal;
